
    <h1 class="recruit">채용알림</h1>
    <div class="news-notice 02t">
        <table>
            <thead>
                <tr>
                    <th>번호</th>
                    <th>제목</th>
                    <th>모집기간</th>
                    <th>등록일</th>
                    <th>진행상태</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor = "let recruit of recruits; let i = index"> 
                    <td>{{i+1}}</td>
                    <td>
                        <a  (click)="showDetail(recruit)">
                            <span>{{recruit.title}}</span>
                        </a>
                    </td>
                    <td *ngIf="recruit.immediateOpening">상시모집</td>
                    <td *ngIf="!recruit.immediateOpening">{{recruit.startDate}} ~ {{recruit.endDate}}</td>
                    <td>{{recruit.creationDate |date: "yyyy.MM.dd"}}</td>
                    <td><span>진행중</span></td>
                </tr>
            </tbody>
        </table>
    </div>
